import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { ContactsEntityType, ContactWithSuspectedMatch } from "../../phonebook/types";
import { DateRange } from "@mui/x-date-pickers-pro";
import axios from "axios";
import { Box, Container, IconButton, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { suspectedMatchesColums } from "./SuspectedMatchesColumns";
import SuspectedMatchesActions from "./SuspectedMatchesActions";
import Iconify from "../../../minimals/components/iconify";
import { NumberParam, StringParam, useQueryParam } from "use-query-params";
import IndividualSuspectedMatchesTab from "./IndividualSuspectedMatches";
import CompanySuspectedMatchesTab from "./CompanySuspectedMatchesTab";

export default function SuspectedMatches() {
  const today = dayjs();
  // const defaultEndDate = dayjs("08/12/2024").endOf("day");
  // const defaultStartDate = dayjs("08/07/2024").startOf("day");
  const defaultEndDate = today.endOf("day");
  const defaultStartDate = today.subtract(7, "days").startOf("day");
  const [selectedEntityId, setSelectedEntityId] = useQueryParam("entityId", StringParam);
  const [selectedEntityType, setSelectedEntityType] = useQueryParam("entityType", NumberParam);

  useEffect(() => {
    if (selectedEntityType === null || selectedEntityType === undefined) {
      setSelectedEntityType(ContactsEntityType.Person);
    }
  }, [selectedEntityType]);

  return (
    <>
     <Box sx={{ width: "100%" }}>
      <Container maxWidth="xl">
        <Typography variant="h4" marginBottom={2}>
          Suspected Matches
        </Typography>
        <Tabs
        value={selectedEntityType}
        onChange={(_, newValue) => setSelectedEntityType(newValue)}
        aria-label="contactTabs"
      >
        <Tab label="Individuals" value={ContactsEntityType.Person} />
        <Tab label="Entities" value={ContactsEntityType.Company} />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {selectedEntityType === ContactsEntityType.Person && (
          <IndividualSuspectedMatchesTab
            setSelectedEntityId={setSelectedEntityId}
            selectedEntityId={selectedEntityId ? Number(selectedEntityId) : undefined}
          />
        )}
        {selectedEntityType === ContactsEntityType.Company && (
          <CompanySuspectedMatchesTab
            setSelectedEntityId={setSelectedEntityId}
            selectedEntityId={selectedEntityId ? Number(selectedEntityId) : undefined}
          />
        )}
      </Box>
        {/* <MaterialReactTable
          enableStickyHeader
          muiTableBodyProps={{
            sx: {
              "& .MuiTableRow-root:hover .MuiTableCell-root": {
                backgroundColor: "inherit !important"
              }
            }
          }}
          muiTableBodyRowProps={({ row }) => {
            return {
              style: row.index % 2 === 0 ? {} : { backgroundColor: "#f4f4f4" }
            };
          }}
          columns={suspectedMatchesColums({ setSuspectedMatch, suspectedMatch })} // Pass state setter
          data={suspectedMatch}
          enableGlobalFilter
          enableFacetedValues
          enableColumnOrdering={enableOrdering}
          initialState={{
            density: "compact",
            pagination: { pageIndex: 0, pageSize: 30 },
            columnVisibility: {
              transactionType: false,
              voidedOn: false,
              status: false,
              extendedMemo: false
            }
          }}
          state={{
            showSkeletons: loading
          }}
          renderTopToolbarCustomActions={({ table }) => {
            return (
              <>
                <SuspectedMatchesActions dateRange={dateRange} setDateRange={setDateRange} table={table} />
                <Tooltip title="Column ordering">
                  <IconButton
                    onClick={() => setEnableOrdering(!enableOrdering)}
                    aria-label="toggle column ordering"
                    style={{ position: "absolute", right: "200px" }}
                  >
                    <Iconify icon="mdi:reorder-vertical" />
                  </IconButton>
                </Tooltip>
              </>
            );
          }}
        /> */}
      </Container>
      </Box>
    </>
  );
}
